import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MeilleursBiensService } from 'app/services/meilleuresBiens/meilleurs-biens.service';
import { SearchService } from 'app/services/search/search.service';

@Component({
  selector: 'app-meilleurs-bien-bizerte',
  templateUrl: './meilleurs-bien-bizerte.component.html',
  styleUrls: ['./meilleurs-bien-bizerte.component.scss']
})
export class MeilleursBienBizerteComponent implements OnInit {

  public MeilleursBiens: any
  p: Number = 1;
  dataSource = new MatTableDataSource();
  closeResult = '';
  search_name1:any;
  public search: string  = ''
  constructor(private meilleursBiensService: MeilleursBiensService,
    private searchService: SearchService) { }
 ngOnInit(): void {
  this.getMeilleursBiensBizerte();
     
  }
  getMeilleursBiensBizerte() {
    this.meilleursBiensService.getMeilleursBiensBizerte().subscribe((data: any) => {
    
      this.MeilleursBiens = data;
     
        console.log('meilleurs biens bizerte',this.MeilleursBiens)
        this.performSearch();

    })
  }

  


  SupprimerMeilleursBiens(MeilleursBiens: any) {
    this.meilleursBiensService.deleteMeilleursBiens(MeilleursBiens.id).subscribe((response: any) => {


      console.log(this.dataSource.data);


    });
 

  }
// Méthode pour effectuer la recherche
performSearch() {
  this.MeilleursBiens = this.searchService.search(this.MeilleursBiens, this.search);
}}
